import React, { useContext } from 'react'

import type { RecipeGridContentBlock } from '@library/api-menu-experience'
import { RecipeGrid } from '@library/menu-page'

import { MenuBrandingContext } from '../menuBrandingContext'

type RecipeGridContentBlockWrapperProps = {
  contentBlock: RecipeGridContentBlock
}

export const RecipeGridContentBlockWrapper = ({
  contentBlock,
}: RecipeGridContentBlockWrapperProps) => {
  const { textColor } = useContext(MenuBrandingContext)

  return <RecipeGrid contentBlock={contentBlock} recipeCountTextColor={textColor} />
}
